
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/agreement",
      function () {
        return require("private-next-pages/policy/agreement.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/agreement"])
      });
    }
  